import { useGetAllDocumentsQuery } from '@entities/common/commonQueries/index.ts';
import { useModules } from '@entities/common/index.ts';
import { type MouseEventHandler, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { usePersonalRedirect } from '@pages/personal/model.ts';
import { useSupportPageRedirect } from '@pages/support/model.ts';
import {
  AgreementIconMenu,
  Exit,
  HomeIconMenu,
  Person,
  Phone,
  SecurityIconMenu,
  ShoppingCart,
} from '@shared/assets';
import { iconsMap } from '@shared/assets/icons/map.tsx';
import { useUser } from '@shared/hooks';
import { useResetPasswordModal } from '@src/modules/Authentication/frames/reset-password-form/model.ts';
import { useLogout } from '../logout/model';
import * as st from './styles.module.scss';

export const MobileLinks: React.FC = () => {
  const { modules } = useModules();
  const { data: documents } = useGetAllDocumentsQuery(undefined);
  const agreement = documents?.agreement;
  const { logout } = useLogout();
  const { isAuth } = useUser();
  const { savePersonalPrevPageUrl } = usePersonalRedirect();
  const { openResetPasswordModal } = useResetPasswordModal();
  const { doSavePageUrl } = useSupportPageRedirect();
  // console.log(mainModules);
  const technicalSupportLink = (
    <HeaderLink
      to={`/support`}
      Icon={<Phone />}
      title={'Техническая поддержка'}
      onClick={doSavePageUrl}
    />
  );
  return (
    <>
      <nav key={'module-1'} className={st.modules}>
        <HeaderLink to={'/'} Icon={<HomeIconMenu />} title={'Главная страница'} />

        {modules.map(
          (mod) =>
            mod.module_type !== 'statistics' && (
              // !(mod.module_type === 'programs' && mod.code !== 'library') &&
              <HeaderLink
                key={mod.id + mod.verbose_name}
                to={`/${mod.module_type}/${mod.code}`}
                Icon={iconsMap[mod.module_type]}
                title={mod.verbose_name}
              />
            )
        )}
      </nav>

      <nav key={'module-2'} className={st.modules}>
        {isAuth && <HeaderLink to={`/cart`} Icon={<ShoppingCart />} title={'Корзина'} />}
        {!isAuth && technicalSupportLink}
      </nav>

      {isAuth && (
        <nav key={'module-3'} className={st.modules}>
          <HeaderLink
            to={`/personal`}
            Icon={<Person />}
            title={'Профиль'}
            onClick={savePersonalPrevPageUrl}
          />

          <HeaderLink
            to={`undefined`}
            Icon={<SecurityIconMenu />}
            title={'Безопасность'}
            onClick={openResetPasswordModal}
          />

          {technicalSupportLink}

          {agreement && (
            <HeaderLink
              to={`/${agreement?.id}`}
              Icon={<AgreementIconMenu />}
              title={'Соглашение'}
            />
          )}
          <HeaderLink to={`undefined`} Icon={<Exit />} title={'Выход'} onClick={logout} />
        </nav>
      )}
    </>
  );
};

function IconWithWrapper({ icon }: { icon: ReactNode }) {
  return <div className={st.iconWrapper}>{icon}</div>;
}

function HeaderLink({
  Icon,
  to,
  title,
  onClick,
}: {
  to: string;
  Icon: ReactNode;
  title: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}) {
  return (
    <Link
      className={st.modules__link}
      to={to}
      onClick={(e) => {
        to === 'undefined' && e.preventDefault();
        onClick && onClick(e);
      }}
    >
      <IconWithWrapper icon={Icon} />
      <span className={st.modules__text}>{title}</span>
    </Link>
  );
}
